import React from "react";
import { useRef, useState, useEffect, Suspense } from "react";
import { Canvas } from "@react-three/fiber";
import gsap from "gsap";
import * as THREE from "three";
import { useFrame, useThree } from "@react-three/fiber";
import { useHelper, Html, CloudInstance, useProgress, OrbitControls } from "@react-three/drei";
import CustomShaderMaterial from "three-custom-shader-material";
import { Scene } from "./Scene";

export const Experience = () => {
  return (
    <div className="relative w-screen md:h-screen h-[100dvh]">
      <Canvas
        dpr={[1, 2]}
        gl={{
          antialias: true,
          preserveDrawingBuffer: true,
        }}
        camera={{
          fov: 55,
          near: 0.1,
          far: 200,
        }}
      >
        <Scene />
        <OrbitControls />
      </Canvas>
    </div>
  );
};
